import { render, staticRenderFns } from "./CardDetailsView.vue?vue&type=template&id=4d8adea4&"
import script from "./CardDetailsView.vue?vue&type=script&lang=js&"
export * from "./CardDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports